import { motion } from "framer-motion";

export const HealthGauge = ({ score = 0, size = 180 }) => {
  const radius = size / 2 - 14;
  const circumference = 2 * Math.PI * radius;
  const pct = Math.max(0, Math.min(100, score));
  const offset = circumference - (pct / 100) * circumference;
  const color = pct >= 75 ? "#8E9E82" : pct >= 50 ? "#E88D67" : "#C56B4A";

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(26,26,26,0.07)" strokeWidth="12" />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray={circumference}
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.4, ease: "easeOut" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <motion.span
          className="font-heading text-charcoal"
          style={{ fontSize: size * 0.28, lineHeight: 1 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          {pct}
        </motion.span>
        <span className="text-[10px] tracking-[0.15em] uppercase font-bold text-sage mt-1">
          Health Score
        </span>
      </div>
    </div>
  );
};
